import React from 'react';

interface Props {
  progressColor: string;
  baseColor: string;
  progressPercentage: number;
  direction?: 'clockwise' | 'counterclockwise';
}

const ProgressCircle: React.FC<Props> = ({
  progressPercentage,
  progressColor,
  baseColor,
  direction = 'counterclockwise'
}) => {
  const radius = 90;
  const circumference = 2 * Math.PI * radius;
  const progressComplete = circumference * progressPercentage;
  const incomplete = circumference - progressComplete;
  const style = direction === 'counterclockwise' ? { transform: 'scaleX(-1)' } : {};
  return (
    <div style={style}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" strokeLinecap="round">
        <circle strokeWidth="20" stroke={baseColor} fill="transparent" cx={100} cy={100} r={90} />
        <circle
          strokeWidth="22"
          stroke={progressColor}
          strokeLinecap="round"
          fill="transparent"
          cx={100}
          cy={100}
          r={radius}
          strokeDasharray={`${progressComplete}, ${incomplete}`}
          transform="rotate(-90 100, 100)"
        />
      </svg>
    </div>
  );
};

export default ProgressCircle;
